/* eslint-disable no-undef */
export const useLocationsStore = defineStore('locations', {
  state: () => ({
    countries: [],
    locations: [],
  }),
})
